import type { HeadcountActualEmployeesQuery } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { type ChildHeadcountRow } from 'modules/planning/types/headcount'
import { defaultChildRow, PARENT_ACTUAL_HEADCOUNT } from 'modules/planning/consts/headcount'

type EmployeeEdge =
  HeadcountActualEmployeesQuery['employees']['employeesConnection']['edges'][number]

const buildJobCatalogLabel = (contract: EmployeeEdge['node']['referenceContract']): string => {
  if (contract?.jobCatalogTreeLevel) {
    const role = contract.jobCatalogTreeLevel.ancestor?.name ?? ''
    const level = contract.jobCatalogTreeLevel.name ?? ''
    return role ? `${role} > ${level}` : level
  }

  if (contract?.jobCatalogLevel) {
    const role = contract.jobCatalogLevel.role?.name ?? ''
    const level = contract.jobCatalogLevel.name ?? ''
    return role ? `${role} > ${level}` : level
  }

  return ''
}

export const mapEmployeeToHeadcountRow = (edge: EmployeeEdge): ChildHeadcountRow => {
  const node = edge.node
  const contract = node.referenceContract
  return {
    ...defaultChildRow,
    id: node.id,
    parentType: PARENT_ACTUAL_HEADCOUNT,
    rowKind: 'employee',
    employeeId: node.id,
    employeeName: node.fullName,
    avatarUrl: buildUrl(node.avatar?.url),
    managerName: node.manager?.fullName ?? '',
    managerAvatarUrl: buildUrl(node.manager?.avatar?.url),
    jobCatalogLabel: buildJobCatalogLabel(contract),
    salary: node.actualHeadcountSalary?.totalSalary ?? '',
    currency: node.legalEntity?.currency ?? '',
    workingTime:
      contract?.workingTimePercentageInCents != null
        ? String(contract.workingTimePercentageInCents / 100)
        : '',
    workplace: node.defaultLocation?.name ?? '',
    startDate: contract?.startsOn ?? '',
    endDate: contract?.endsOn ?? '',
    jobCatalogTreeNodeUuid: contract?.jobCatalogTreeLevel?.uuid ?? '',
    oldJobCatalogLevelId: contract?.jobCatalogLevel?.id ?? '',
  }
}
